import { render, staticRenderFns } from "./PreInvoiceList.vue?vue&type=template&id=bab4f6fc&scoped=true&"
import script from "./PreInvoiceList.vue?vue&type=script&lang=js&"
export * from "./PreInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./PreInvoiceList.vue?vue&type=style&index=0&id=bab4f6fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab4f6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bab4f6fc')) {
      api.createRecord('bab4f6fc', component.options)
    } else {
      api.reload('bab4f6fc', component.options)
    }
    module.hot.accept("./PreInvoiceList.vue?vue&type=template&id=bab4f6fc&scoped=true&", function () {
      api.rerender('bab4f6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/History/PreInvoiceList.vue"
export default component.exports